import { render, staticRenderFns } from "./GiftPostForm.vue?vue&type=template&id=57e17263&"
import script from "./GiftPostForm.vue?vue&type=script&lang=js&"
export * from "./GiftPostForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports